(function () {
  'use strict';

  var $ = function (sel, root) {
    return (root || document).querySelector(sel);
  };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  var openOverlays = [];
  var lastFocused = null;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, event) {
    var focusable = $$(FOCUSABLE, container).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openOverlay(el, onOpen) {
    if (!el || openOverlays.indexOf(el) !== -1) return;

    lastFocused = document.activeElement;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    openOverlays.push(el);

    if (openOverlays.length === 1) document.body.classList.add('no-scroll');

    var autofocus = $('[data-overlay-autofocus]', el) || $$(FOCUSABLE, el)[0];
    if (autofocus) autofocus.focus();

    if (onOpen) onOpen(el);
  }

  function closeOverlay(el) {
    if (!el) return;

    var i = openOverlays.indexOf(el);
    if (i !== -1) openOverlays.splice(i, 1);

    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');

    if (openOverlays.length === 0) {
      document.body.classList.remove('no-scroll');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }
  }

  document.addEventListener('keydown', function (e) {
    if (!openOverlays.length) return;
    var top = openOverlays[openOverlays.length - 1];

    if (e.key === 'Escape') closeOverlay(top);
    if (e.key === 'Tab') trapFocus(top, e);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-overlay-open]');
    if (opener) {
      e.preventDefault();
      openOverlay($('[data-overlay="' + opener.dataset.overlayOpen + '"]'));
      return;
    }

    var closer = e.target.closest('[data-overlay-close]');
    if (closer) {
      e.preventDefault();
      closeOverlay(closer.closest('[data-overlay]'));
    }
  });

  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;

    try {
      if (sessionStorage.getItem('duncan:announcement-dismissed') === '1') {
        bar.remove();
        return;
      }
    } catch (err) {
    }

    var close = $('[data-announcement-close]', bar);
    if (!close) return;

    close.addEventListener('click', function () {
      bar.remove();
      try {
        sessionStorage.setItem('duncan:announcement-dismissed', '1');
      } catch (err) {
      }
    });
  }

  function initMegaMenus() {
    $$('[data-mega-parent]').forEach(function (parent) {
      var menu = $('[data-mega]', parent);
      var toggle = $('[data-mega-toggle]', parent);
      if (!menu) return;

      var closeTimer;
      var hoverCapable = window.matchMedia('(hover: hover)').matches;

      function show() {
        clearTimeout(closeTimer);
        menu.hidden = false;
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }

      function hide() {
        closeTimer = setTimeout(function () {
          menu.hidden = true;
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }, 80);
      }

      if (hoverCapable) {
        parent.addEventListener('mouseenter', show);
        parent.addEventListener('mouseleave', hide);
      }

      parent.addEventListener('focusin', show);
      parent.addEventListener('focusout', function (e) {
        if (!parent.contains(e.relatedTarget)) hide();
      });

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          if (!hoverCapable && menu.hidden) {
            e.preventDefault();
            show();
          }
        });
      }

      $$('a', menu).forEach(function (a) {
        a.addEventListener('click', function () {
          menu.hidden = true;
        });
      });
    });
  }

  function initMobileNav() {
    $$('[data-mobile-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-mobile-item]');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

 
  var footerAccordionQuery = window.matchMedia('(max-width: 767px)');

  function syncFooterAccordions() {
    $$('[data-footer-accordion]').forEach(function (group) {
      var toggle = $('[data-footer-accordion-toggle]', group);
      if (!toggle) return;

      var panel = $('[data-footer-accordion-panel]', group);

      if (panel && footerAccordionQuery.matches) {
        toggle.disabled = false;
        toggle.setAttribute('aria-controls', panel.id);
        toggle.setAttribute('aria-expanded', String(panel.classList.contains('is-open')));
        return;
      }

      toggle.disabled = true;
      toggle.removeAttribute('aria-expanded');
      toggle.removeAttribute('aria-controls');
      if (panel) panel.classList.remove('is-open');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-footer-accordion-toggle]');
    if (!toggle || toggle.disabled) return;

    var group = toggle.closest('[data-footer-accordion]');
    var panel = $('[data-footer-accordion-panel]', group);
    if (!panel) return;

    var open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  footerAccordionQuery.addEventListener('change', syncFooterAccordions);

  function initReveals(root) {
    var scope = root || document;
    var items = $$('.reveal:not(.is-visible)', scope);
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('no-reveal')) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    $$('[data-stagger]', scope).forEach(function (group) {
      var step = parseInt(group.dataset.stagger, 10) || 80;
      $$(':scope > .reveal, :scope > * > .reveal', group).forEach(function (el, i) {
        el.style.setProperty('--reveal-delay', i * step + 'ms');
      });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.01 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-step]');
    if (!btn) return;

    var wrapper = btn.closest('[data-quantity]');
    var input = $('input[type="number"]', wrapper);
    if (!input) return;
    var min = parseInt(input.min, 10);
    if (Number.isNaN(min)) min = 1;

    var max = input.max ? parseInt(input.max, 10) : Infinity;

    var current = parseInt(input.value, 10);
    if (Number.isNaN(current)) current = min;

    var next = Math.min(max, Math.max(min, current + parseInt(btn.dataset.quantityStep, 10)));
    if (next === current) return;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details.matches || !details.matches('[data-exclusive-group] details')) return;
    if (!details.open) return;

    var group = details.closest('[data-exclusive-group]');
    $$('details[open]', group).forEach(function (other) {
      if (other !== details) other.open = false;
    });
  }, true);

  function init() {
    initAnnouncement();
    initMegaMenus();
    initMobileNav();
    syncFooterAccordions();
    initReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initMegaMenus();
    initMobileNav();
    syncFooterAccordions();
    initReveals(e.target);
  });

  window.Duncan = {
    $: $,
    $$: $$,
    openOverlay: openOverlay,
    closeOverlay: closeOverlay,
    initReveals: initReveals
  };
})();

(function () {
  var utility = document.querySelector('.utilitybar');
  var mainHeader = document.querySelector('.header-section');
  if (utility && mainHeader) {
    var utilityHeight = utility.getBoundingClientRect().height;
    mainHeader.style.setProperty('--utility-height', '-' + utilityHeight + 'px');
  }
  if (window.innerWidth > 767) return;
  var header = document.querySelector('.site-header');
  var shopToolbar = document.querySelector('.shop-toolbar');
  if (!header || !shopToolbar) return;
  var headerHeight = header.getBoundingClientRect().height;
  shopToolbar.style.setProperty('--header-height', headerHeight + 'px');
})();